import { Component, OnInit } from '@angular/core';

import { LesseeService } from '../../services/lessee.service';
import { OrganizationService } from '../../services/organization.service';

@Component({
  selector: 'app-lessee-landing',
  templateUrl: './lessee-landing.component.html',
  styleUrls: ['./lessee-landing.component.scss']
})
export class LesseeLandingComponent implements OnInit {
  organization;
  lease;
  property;
  loading = true;
  error: string | null = null;

  constructor(private lesseeService: LesseeService, private organizationService: OrganizationService) { }

  ngOnInit() {
    this.organizationService.getOrganization().then((org) => {
      this.organization = org;
    }).catch(() => {});

    Promise.all([
      this.lesseeService.getLeasedProperty(),
      this.lesseeService.getActiveLease()
    ]).then(([property, activeLease]) => {
      this.property = property;
      this.lease = activeLease;
    }).catch((err) => {
      const msg = (err && err.error && err.error.error) || (err && err.message) || 'Failed to load property and lease information.';
      this.error = msg;
    }).finally(() => {
      this.loading = false;
    });
  }

  isMonthToMonthLease(): boolean {
    return !!this.lease && (this.lease.type === 'M2M' || (!this.lease.startDate && !this.lease.endDate));
  }
}
